import React from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { PropertyCard } from "properties/PropertyCard";
import { TPropertyListingMdl } from "properties/_models/PropertyMdl";
import { FeaturedPropertiesCarousel } from "home/sections/FeaturedPropertiesCarousel";
import styles from "./_css/featuredProperties.module.css";

export function FeaturedProperties({
    properties,
    pageBuilder,
    carousel,
}: {
    properties: TPropertyListingMdl[];
    pageBuilder?: boolean;
    carousel?: boolean;
}) {
    // en mode carrousel on affiche toutes les proprietes remontees (forfait EXCLUSIF + placements
    // en vedette), la grille elle reste limitee a 3 cartes
    if (carousel) return <FeaturedPropertiesCarousel properties={properties} pageBuilder={pageBuilder} />;
    return (
        <div id="featuredProperties" className={styles.grid}>
            {properties.slice(0, 3).map((property) => {
                if (!property) return null;
                return <PropertyCard key={property._id} isFeaturedCard pageBuilder={pageBuilder} property={property} />;
            })}
        </div>
    );
}
